import { render, staticRenderFns } from "./AddCategoryServiceDialog.vue?vue&type=template&id=1ebf424b&scoped=true"
import script from "./AddCategoryServiceDialog.vue?vue&type=script&lang=js"
export * from "./AddCategoryServiceDialog.vue?vue&type=script&lang=js"
import style0 from "./AddCategoryServiceDialog.vue?vue&type=style&index=0&id=1ebf424b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf424b",
  null
  
)

export default component.exports